import {
  useState,
  createContext,
  useContext,
  useCallback,
  useEffect,
} from 'react';
import PropTypes from 'prop-types';

const DEFAULT_STATE = {
  viewportId: null,
  message: undefined,
  type: 'info', // "error" | "warning" | "info" | "success"
  actions: undefined, // array of { type, text, value }
  // dismissable?
  // blockInteraction (single viewport? allViewports? everything?)
  // TODO: Buttons --> type/color? text? value?
  onSubmit: () => {
    console.log('btn value?');
  },
  onOutsideClick: () => {
    console.warn('default: onOutsideClick');
  },
  onDismiss: () => {
    console.log('dismiss? -1');
  },
};

const ViewportDialogContext = createContext(null);
const ViewportDialogDispatch = createContext(null);

export const useViewportDialogContext = () => useContext(ViewportDialogContext);
export const useViewportDialogDispatch = () =>
  useContext(ViewportDialogDispatch);
export const useViewportDialog = () => [
  useContext(ViewportDialogContext),
  useContext(ViewportDialogDispatch),
];

const ViewportDialogProvider = ({ children, service }) => {
  const [viewportDialogState, setViewportDialogState] = useState(DEFAULT_STATE);
  const show = useCallback(
    (params) => {
      setViewportDialogState({ ...viewportDialogState, ...params });
    },
    [viewportDialogState, setViewportDialogState]
  );
  const hide = useCallback(() => {
    setViewportDialogState(DEFAULT_STATE);
  }, [setViewportDialogState]);

  useEffect(() => {
    if (service) {
      service.setServiceImplementation({ hide, show });
    }
  }, [hide, show]);

  const api = {
    show: (props) => service.show(props),
    hide: () => service.hide(),
  };

  return (
    <ViewportDialogContext.Provider value={viewportDialogState}>
      <ViewportDialogDispatch.Provider value={api}>
        {children}
      </ViewportDialogDispatch.Provider>
    </ViewportDialogContext.Provider>
  );
};

ViewportDialogProvider.propTypes = {
  /** Children that will be wrapped with Modal Context */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  service: PropTypes.shape({
    setServiceImplementation: PropTypes.func,
  }),
};

export default ViewportDialogProvider;
